import { PartnersService } from './../../partners.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Subscription } from 'rxjs';
import { SettingsService } from '../../../contexts/settings/settings.service';
import { PartnersTunaService } from '../../../contexts/partners/partners-tuna.service';

@Component({
  selector: 'app-layout-select-partner',
  templateUrl: './select-partner.component.html'
})
export class LayoutSelectPartnerComponent implements OnInit {

  @Output() accountChange = new EventEmitter();
  @Input() user;
  model: any = {};
  subscription: Subscription;
  @Output() getNotifications = new EventEmitter();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private settingsService: SettingsService,
    private partnersService: PartnersService,
    private keycloakService: KeycloakService,
    private partnerService: PartnersTunaService
  ) { }

  async ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.model.partner = params.get('partner');
      this.model.account = params.get('account');
    });

    if (await this.keycloakService.isLoggedIn()) {

      this.partnersService.accounts(this.model.partner, this.model.account).subscribe(
        async (success) => {
          this.model.user = await this.keycloakService.loadUserProfile();

          var access_account = success.some(p => p.key == this.model.account);
          if (!access_account && success.length > 0) {

            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {

              this.router.navigate([
                this.model.partner,
                success[0].key,
                'transactions'
              ]);
            });
          } else {

            if (access_account) {

              this.partnerService.check(this.model.partner).subscribe(
                async (response) => {
                  if (response) {
                    this.model.user = await this.keycloakService.loadUserProfile();
                    if (success.length > 0) {
                      this.model.accounts = success;
                      this.model.accounts.forEach(element => {
                        if (element.configurations) {
                          let obj = JSON.parse(element.configurations);
                          element.color = obj.Frontend ? obj.Frontend.Color : '#000';
                        }
                        else
                          element.color = '#000';
                      });

                      this.selectAccount(this.model.accounts.find(p => p.key == this.model.account));

                      this.model.partnerObj = this.model.accounts.find(p => p.key == this.model.account).partner;
                      this.getNotification();
                      this.firstLetter();
                    }
                    else {
                      await this.keycloakService.logout();
                    }
                  } else {
                    await this.keycloakService.logout();
                  }
                }
              );
            } else {
              await this.keycloakService.logout();
            }
          }
        }
      );

      this.subscription = this.settingsService.currentParnter.subscribe(async (account) => {
        if (Object.keys(account).length > 0) {
          this.selectAccount(account);
        }
      });

    }
  }

  settings(account) {
    this.selectAccount(account);
    this.router.navigate([this.model.partner, account.key, 'settings', 'company']);
  }

  changeAccount(account) {
    if (account.key !== this.model.accountSelected?.key) {
      this.selectAccount(account);
      this.router.navigate([this.model.partner, account.key]);
    }
  }

  getNotification() {

    this.getNotifications.emit(this.model.partnerObj);
  }

  firstLetter() {
    this.model.firstLetter = this.model.accountSelected.name.charAt(0);
  }

  selectAccount(account) {
    this.model.accountSelected = account;
    this.accountChange.emit(account);
  }
}
